import React from 'react';
import styles from '../BottomDrawer.module.scss';

interface BottomDrawerHeaderProps {
    children?: React.ReactNode;
    width?: string;
}
function BottomDrawerHeader({ children, width }: BottomDrawerHeaderProps) {
    return (
        <div className={styles.DrawerHeader}>
            <div style={width ? { width: width } : {}}>{children}</div>
        </div>
    );
}

export default BottomDrawerHeader;
